import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  ForgotPassword,
  RequireNewPassword,
  SignIn,
  ConfirmSignUp,
  VerifyContact,
  Loading,
  AmplifyTheme
} from "aws-amplify-react/dist/Auth";
import ErrorBoundry from "./components/ErrorBoundry";
import { getHotelSettings } from "./redux/settings/actions";
import CustomWithAuthenticator from "./components/CustomAmplifyComponents/customWithAuthenticator";
import CustomForgotPassword from "./components/CustomAmplifyComponents/CustomForgotPassword";
import CustomSignIn from "./components/CustomAmplifyComponents/CustomSignIn";
import CustomVerifyContact from "./components/CustomAmplifyComponents/CustomVerifyContact";
import CustomAmplifyTheme from "./components/CustomAmplifyComponents/CustomAmplifyTheme";
import { isMultiColorActive, defaultColor, themeColorStorageKey, isDarkSwitchActive } from "./constants/defaultValues";

class AppWithLoader extends Component {
  componentDidMount() {
    this.props.getHotelSettings();
    this.getHotelSettingsTimer = setTimeout(() => {
      this.props.getHotelSettings();
    }, 60 * 60 * 1000);
    this.importCSS();
  }

  componentWillUnmount() {
    clearTimeout(this.getHotelSettingsTimer);
  }

  importCSS = () => {
    const {
      hotelConfig: { theme }
    } = this.props;
    const color =
      (isMultiColorActive || isDarkSwitchActive) && localStorage.getItem(themeColorStorageKey)
        ? localStorage.getItem(themeColorStorageKey)
        : defaultColor;

    localStorage.setItem(themeColorStorageKey, color);
    if (theme) {
      return import(`./assets/css/sass/themes/${theme}.scss`);
    }
    return import(`./assets/css/sass/themes/gogo.${color}.scss`);
  };

  render() {
    const { isSettingsLoaded } = this.props;
    if (isSettingsLoaded) {
      return (
        <ErrorBoundry>
          <CustomWithAuthenticator
            includeGreetings={false}
            authenticatorComponents={[
              <CustomSignIn override={SignIn} />,
              <ConfirmSignUp />,
              <CustomForgotPassword override={ForgotPassword} />,
              <RequireNewPassword />,
              // <TOTPSetup />,
              <CustomVerifyContact override={VerifyContact} />,
              <Loading />
            ]}
            federated={null}
            theme={CustomAmplifyTheme || AmplifyTheme}
            Comp={this}
          />
        </ErrorBoundry>
      );
    }
    return <span className="spinner d-inline-block" />;
  }
}

AppWithLoader.propTypes = {
  hotelConfig: PropTypes.object.isRequired,
  isSettingsLoaded: PropTypes.bool.isRequired
};

const mapStateToProps = ({ settings }) => {
  const { isSettingsLoaded, force_reload, hotelConfig } = settings;
  return { isSettingsLoaded, force_reload, hotelConfig };
};
const mapActionsToProps = { getHotelSettings };

export default connect(
  mapStateToProps,
  mapActionsToProps
)(AppWithLoader);
